'use client';

import React from 'react';
import styles from './TokenSwiperLink.module.scss';
import Link from 'next/link';
import type { Token } from './TokenSwiper';
import { TokenIcon } from '@/components/elements/TokenIcon';
import { formatPrice } from '@/utils/formatPrice';
import { PercentageChangeBlock } from '@/components/elements/PercentageChangeBlock';
import { useRouter } from 'next/navigation';
import { generateTokenUrl } from '@/utils/tokenUrls';

export const TokenSwiperLink: React.FC<{ token: Token; changeParameter?: 'price' | 'volume'; linkIndex?: number }> = ({ token, changeParameter = 'price', linkIndex = 0 }) => {
  // Helper to get volumeChange24h from all possible locations
  const getVolumeChange24h = () => {
    if (token.price && typeof token.price.volumeChange24h === 'number') return token.price.volumeChange24h;
    if (typeof token.volume24h === 'object' && token.volume24h && typeof (token.volume24h as any).change === 'number') return (token.volume24h as any).change;
    return undefined;
  };
  const volumeChange24h = getVolumeChange24h();
  const router = useRouter();
  const tokenHref = generateTokenUrl(token);

  return (
    <Link
      href={tokenHref}
      className={styles.tokenBox}
      prefetch={false}
      onMouseEnter={() => router.prefetch(tokenHref)}
    >
      <TokenIcon 
        src={token.imageUri} 
        alt={token.symbol} 
        className={styles.tokenImg} 
        verified={token.verified} 
        index={linkIndex}
        isSwiper={true}
      />
      <div className={styles.tokenInfo}>
        <div className={styles.tokenName}>{token.symbol}</div>
        <div className={styles.tokenPrice}> ${token.price?.usdPrice ? formatPrice(token.price.usdPrice) : '-'}</div>
      </div>
      {changeParameter === 'price'
        ? token.price?.change != null
          ? <PercentageChangeBlock value={token.price.change} fontSize={16} className={styles.trendingIcon} />
          : '-'
        : typeof volumeChange24h === 'number'
          ? <PercentageChangeBlock value={volumeChange24h * 100} fontSize={16} className={styles.trendingIcon} />
          : '-'}
    </Link>
  );
};
